import posthog from "posthog-js";
import { axiosBasic, getUserInfo } from "../../../../api/axios";
import { config } from "../../../../api/endPoints";

// Action Types
export const SETTINGS_ACTION_TYPES = {
    FETCH_SETTINGS_REQUEST: "FETCH_SETTINGS_REQUEST",
    FETCH_SETTINGS_SUCCESS: "FETCH_SETTINGS_SUCCESS",
    FETCH_SETTINGS_FAILURE: "FETCH_SETTINGS_FAILURE",
    UPDATE_SETTINGS_REQUEST: "UPDATE_SETTINGS_REQUEST",
    UPDATE_SETTINGS_SUCCESS: "UPDATE_SETTINGS_SUCCESS",
    UPDATE_SETTINGS_FAILURE: "UPDATE_SETTINGS_FAILURE",
    RESET_SETTINGS: "RESET_SETTINGS",
};

// Action Creators
export const fetchSettingsRequest = () => ({
    type: SETTINGS_ACTION_TYPES.FETCH_SETTINGS_REQUEST,
});

export const fetchSettingsSuccess = (settings) => ({
    type: SETTINGS_ACTION_TYPES.FETCH_SETTINGS_SUCCESS,
    payload: settings,
});

export const fetchSettingsFailure = (error) => ({
    type: SETTINGS_ACTION_TYPES.FETCH_SETTINGS_FAILURE,
    payload: error,
});

export const updateSettingsRequest = () => ({
    type: SETTINGS_ACTION_TYPES.UPDATE_SETTINGS_REQUEST,
});

export const updateSettingsSuccess = (settings) => ({
    type: SETTINGS_ACTION_TYPES.UPDATE_SETTINGS_SUCCESS,
    payload: settings,
});

export const updateSettingsFailure = (error) => ({
    type: SETTINGS_ACTION_TYPES.UPDATE_SETTINGS_FAILURE,
    payload: error,
});

export const resetSettings = () => ({
    type: SETTINGS_ACTION_TYPES.RESET_SETTINGS,
});

// Async Action Creators
export const fetchSettings = () => {
    return async (dispatch) => {
        const userId = getUserInfo()?.selfUserId ?? null;
        const userInput = {};
        try {
            dispatch(fetchSettingsRequest());

            const response = await axiosBasic.get(config.REST_API.Company.GetSettings);
            const success = response.data.success;
            if (typeof posthog !== "undefined" && posthog.capture) {
                posthog.capture("fetchSettings", {
                    type: success ? "info" : "exception",
                    userId,
                    success,
                    userInput,
                    reason: success ? undefined : (response.data.message || "Failed to fetch settings"),
                });
            }
            if (success) {
                dispatch(fetchSettingsSuccess(response.data.data));
            } else {
                dispatch(fetchSettingsFailure(response.data.message || "Failed to fetch settings"));
            }
            return response.data.data;
        } catch (error) {
            if (typeof posthog !== "undefined" && posthog.capture) {
                posthog.capture("fetchSettings", {
                    type: "exception",
                    userId,
                    success: false,
                    userInput,
                    reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
                });
            }
    
            dispatch(fetchSettingsFailure(error.message || "Failed to fetch settings"));
            throw error;
        }
    };
};

export const updateSettings = (fieldName, value) => {
    return async (dispatch) => {
        const userId = getUserInfo()?.selfUserId ?? null;
        const userInput = { fieldName, hasValue: value !== undefined && value !== null };
        try {
            dispatch(updateSettingsRequest());

            const requestData = {
                FieldName: fieldName,
                Value: value
            };

            const response = await axiosBasic.put(config.REST_API.Company.UpdateSettings, requestData);

            const success = response.data.success;
            if (typeof posthog !== "undefined" && posthog.capture) {
                posthog.capture("updateSettings", {
                    type: success ? "info" : "exception",
                    userId,
                    success,
                    userInput,
                    reason: success ? undefined : (response.data.message || "Failed to update settings"),
                });
            }
            if (success) {
                dispatch(updateSettingsSuccess(response.data.data));
            } else {
                dispatch(updateSettingsFailure(response.data.message || "Failed to update settings"));
            }
            return response.data.data;
        } catch (error) {
            if (typeof posthog !== "undefined" && posthog.capture) {
                posthog.capture("updateSettings", {
                    type: "exception",
                    userId,
                    success: false,
                    userInput,
                    reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
                });
            }
        
            dispatch(updateSettingsFailure(error.message || "Failed to update settings"));
            throw error;
        }
    };
};
